// package
import { AES, enc } from "crypto-js";
import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";
import moment from "moment";
// includes
import { SideBarType, LayoutWidth } from "includes/types";
import { config } from "includes";
import { types } from "../helpers/types";

interface ConfigTypes {
  leftSideBarTypes:
  | SideBarType.LEFT_SIDEBAR_TYPE_COMPACT
  | SideBarType.LEFT_SIDEBAR_TYPE_CONDENSED
  | SideBarType.LEFT_SIDEBAR_TYPE_DEFAULT
  | SideBarType.LEFT_SIDEBAR_TYPE_FULL
  | SideBarType.LEFT_SIDEBAR_TYPE_FULLSCREEN
  | SideBarType.LEFT_SIDEBAR_TYPE_HOVER;
}

export const common = {
  loadImg(img: string) {
    let result = require("../assets/images/" + img);
    return result; //.default;
  },

  cloudImg(img: string) {
    let result = img
      ? config.api.cloudImgPath + img
      : common.loadImg("dummy-avatar.jpg");
    return result; //.default;
  },

  openCloudUrl(url: string) {
    window.open(config.api.cloudImgPath + url, "_blank");
  },

  fileName(file: string) {
    let ext = file.substring(file.lastIndexOf("."));
    let fileName = file.split("_").slice(0, -1).join("_") + ext;
    return fileName.substring(fileName.indexOf("/") + 1);
  },

  // local storage
  localSet(key: string, value: any) {
    if (typeof value === "object") {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  },

  localGet(key: string, json: boolean = false) {
    let value: any = localStorage.getItem(key);
    if (json) {
      value = JSON.parse(value);
    }
    return value;
  },

  localRemove(key: string) {
    localStorage.removeItem(key);
  },

  // local data
  localDataSet(value: any) {
    this.localSet("localData", value);
  },

  localDataGet() {
    let res = this.localGet("localData", true);
    this.localDataRemove();
    return res;
  },

  localDataRemove() {
    return this.localRemove("localData");
  },

  // tempdata
  tempDataSet(value: any) {
    this.localSet("tempData", common.crypt(value, true));
  },

  tempDataGet() {
    let data = this.localGet("tempData");
    if (data) {
      return this.deCrypt(data, true);
    }
    return null;
  },

  tempDataRemove() {
    return this.localRemove("tempData");
  },

  authInfo: (token: any) => {
    return jwtDecode(token);
  },

  // auth
  checkAuth() {
    let authData = this.localGet("authData");
    if (authData == "" || authData == null) {
      return false;
    } else {
      return !!this.getAuth();
    }
  },

  getAuth() {
    let data = this.localGet("authData");
    return this.deCrypt(data, true);
  },

  // encode decode
  crypt(str: any, json = false) {
    if (json) {
      str = JSON.stringify(str);
    }
    return AES.encrypt(str, config.cryptKey).toString();
  },

  deCrypt(str: any, json = false) {
    try {
      let bytes = AES.decrypt(str, config.cryptKey);
      let data = bytes.toString(enc.Utf8);
      if (data == "") {
        localStorage.clear();
        this.redirect("login");
      } else if (json) {
        return JSON.parse(data);
      } else {
        return data;
      }
    } catch (err) {
      localStorage.clear();
      this.redirect("login");
    }
  },

  // validation
  isEmail(mail: string) {
    return !!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail);
  },

  scrollToRef(myRef: any, adjust = 0) {
    window.scroll({
      top: myRef.current.offsetTop - adjust,
      behavior: "smooth",
    });
  },

  scrollTo(to = "") {
    if (to === "top") {
      window.scroll({ top: 0, behavior: "smooth" });
    } else if (to === "bottom") {
      window.scrollTo({
        left: 0,
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }
  },

  // validate

  validateMobile(number: string) {
    return number.replace(/[^0-9]/g, "");
  },

  // input
  onlyNumbers(str: string) {
    return str.replace(/[^0-9]/g, "");
  },

  onlyFloat(str: string) {
    return str.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1");
  },

  getNumWithComma(str: string) {
    return common.onlyFloat(str).replace(/(\d)(?=(\d{3})+\b)/g, "$1,");
  },

  redirect(url: string = "") {
    window.location.href = config.public_url + url;
  },

  splitArray(array: Array<any>, chunkSize: number) {
    const chunks = Array(Math.ceil(array.length / chunkSize))
      .fill(1)
      .map((_, index) => index * chunkSize)
      .map((begin) => array.slice(begin, begin + chunkSize));
    return chunks;
  },

  getLayoutConfigs(layoutWidth: string) {
    // add property to change in particular layoutWidth
    let config: ConfigTypes = {
      leftSideBarTypes: SideBarType.LEFT_SIDEBAR_TYPE_DEFAULT,
    };

    switch (layoutWidth) {
      case LayoutWidth.LAYOUT_WIDTH_FLUID:
        config.leftSideBarTypes = SideBarType.LEFT_SIDEBAR_TYPE_DEFAULT;
        break;
      case LayoutWidth.LAYOUT_WIDTH_BOXED:
        config.leftSideBarTypes = SideBarType.LEFT_SIDEBAR_TYPE_CONDENSED;
        break;
      default:
        return config;
    }
    return config;
  },

  changeHTMLAttribute(attribute: string, value: string) {
    if (document.body)
      document.getElementsByTagName("html")[0].setAttribute(attribute, value);
  },

  reParse(data: any) {
    return data ? JSON.parse(JSON.stringify(data)) : {};
  },

  /**
   * Format date
   */
  formatDate(date: Date, format: string, gmt?: boolean) {
    if (!format) format = "D MMM - h:mm a";
    if (gmt) {
      return moment.utc(date).format(format);
    } else {
      return moment.utc(date).local().format(format);
    }
  },

  randomString() {
    let length = 15;
    let chars =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var result = "";
    for (var i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  },

  ValidateEmail(mail: any) {
    //let regExp = /^[A-Za-z0-9-+&]+(\.[A-Za-z0-9-+]+)*(\+[A-Za-z0-9-&]+)?@[A-Za-z0-9-.]+(\.\w{2,10})+$/; // allow +&
    let regExp = new RegExp(
      "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
    );
    if (regExp.test(mail)) {
      return true;
    } else {
      return false;
    }
  },

  formPayload(fields: any, nullExlcudeFields: Array<String>) {
    let data: any = {};

    for (const key in fields) {
      let value: any = fields[key];
      if (value instanceof Date) {
        value = common.formatDate(value, "YYYY-MM-DDTHH:mm:ssZ", true);
      } else if (!value && nullExlcudeFields.includes(key)) {
        value = "";
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          let result: any = [];
          fields[key]?.map((obj: any) => {
            result.push(obj?.value);
          });
          value = result;
        } else {
          value = value?.value;
        }
      }
      data[key] = value;
    }
    return data;
  },

  logout() {
    localStorage.clear();
    this.redirect("/login");
  },

  generatePassword() {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let password = "";
    for (let i = 0; i < 10; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      password += chars[randomIndex];
    }
    return password;
  },

  notify(type: string, msg: string) {
    toast.dismiss();
    switch (type) {
      case "S":
        toast.success(msg, config.elements.toast);
        break;
      case "W":
        toast.warning(msg, config.elements.toast);
        break;
      case "E":
        toast.error(msg, config.elements.toast);
        break;
      case "I":
        toast.info(msg, config.elements.toast);
        break;
      case "M":
        toast(msg, config.elements.toast);
        break;
    }
  },

  compare(a: any, b: any) {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  },

  readable(data: any = {}) {
    return data ? Object.values(data).join(", ") : "-";
  },
  FindMultiSelect(data: any, val: any) {
    if (val && Array.isArray(val)) {
      let result = data.filter((obj: any) => val.includes(obj?.value?.toString()));
      return result ?? null;
    } else {
      let result = data.find(
        (obj: any) => val?.value?.toString() === obj?.value?.toString()
      );
      return result ?? null;
    }
  },
  FindMultiSelect1(data: any[], val: any): any[] {
    if (Array.isArray(val)) {
      const result = val.map((v) => {
        const targetValue = typeof v === "object" ? v?.value?.toString() : v?.toString();
        return data.find((obj) => obj?.value?.toString() === targetValue) || null;
      }).filter(Boolean); // Remove any nulls
      return result;
    } else {
      const targetValue = typeof val === "object" ? val?.value?.toString() : val?.toString();
      const result = data.find((obj) => obj?.value?.toString() === targetValue);
      return result ? [result] : [];
    }
  },


  FindSelect(data: any, val: any) {
    let result = data.find((obj: any) => obj.value?.toString() === val?.toString());
    return result ?? null;
  },


  SetMultiSelect(data: any, label: any, value: any, join = "") {
    let optionsData: any = [];
    //   if (Array.isArray(data)) {
    //   data.forEach((obj: any, index: number) => {
    //     console.log("=====obj", obj, value);

    //     const rawLabel = obj[label];
    //     let rawValue = obj[value];

    //      // Fallback unique value if undefined
    //     if (!rawValue && rawValue !== 0) {
    //       rawValue = `${join || "item"}-${obj.id ?? index}`;
    //     }

    //     optionsData.push({
    //       ...obj,
    //       label: typeof rawLabel === "string" ? rawLabel.trim() : `Option ${index + 1}`,
    //       value: rawValue,
    //     });
    //   });
    // }
    if (data && data.length) {
      data.map((obj: any) => {
        let options = {
          label: obj[label],
          value: obj[value],
          ...obj
        };
        optionsData.push(options);
      });
    }
    return optionsData;
  },

  filterSet(filterData: any, data: any) {
    let fData: any = {};
    let nData: any = common.reParse(filterData);
    let t: any = types;
    Object.entries(nData).map(([key, item]: any) => {
      let type: any = t?.filterFields[key]?.type;
      if (type === "array" && data[key] && data[key]?.length > 0) {
        fData[item.key] = data[key].length > 0 ? data[key].map((i: any) => i?.value) : "";
      } else if (type === "object") {
        fData[item.key] = data[key] ? data[key]?.value : "";
      } else if (type === "boolObject") {
        fData[item.key] = data[key] ? data[key]?.value : "";
      } else if (type === "date") {
        fData[item.key] = data[key] ? moment.utc(data[key]).local().format('YYYY-MM-DD') : "";
      } else if (type === "arrObject") {
        let filtered = data[key].map((a: any) => a.value);
        fData[item.key] = data[key]?.length > 0 ? filtered : null;
      } else if (type === "text") {
        fData[item.key] = data[key] || ""
      }
    });
    return fData;
  },

  filterReset(data: any, useKey = false) {
    let fData: any = {};
    let nData = common.reParse(data);
    let t: any = types;
    Object.entries(nData).map(([key, item]: any) => {
      fData[useKey ? key : item.key] = t.filterFields[key].value;
    });
    return fData;
  },

  filterParse(data: any, useKey = false) {
    let fData: any = {};
    let nData = common.reParse(data);
    let t: any = types;
    Object.entries(nData).map(([key, item]: any) => {
      let finder = t?.filterFields[key]?.finder;
      if (useKey && finder) {
        fData[useKey ? key : item.key] = common.FindSelect(
          t[finder],
          item.value
        );
      } else {
        fData[useKey ? key : item.key] = item.value;
      }
    });
    return fData;
  },
  isDateValid(dateStr: any) {
    let d: any = new Date(dateStr);
    // @ts-nocheck
    return moment(dateStr, "MM/DD/YYYY", true).isValid();
    // !isNaN(d);
  },

  selectOption(data: any) {
    let optionsData: any = [];
    if (data && data.length) {
      data.map((obj: any) => {
        let options = {
          label: obj,
          value: obj
        };
        optionsData.push(options);
      });
    }
    return optionsData;
  },

  getPermission() {
    let result: any = [];
    types.permission.list.map((i: any) =>
      i.types.map((j: any) => {
        result.push(i.key + j);
      })
    );
    return result;
  },

  getUserPermission() {
    let result = this.getAuth();
    return result?.permission;
  },

  accessTable(permission: any, permissionKey: any) {
    let access: any = [];
    let pr: any = {
      r: "View",
      u: "Edit",
      c: "Add",
      d: "Delete",
    };
    permission.map((val: any) => {
      if (permissionKey.includes(val)) {
        access.push(pr[val[val.length - 1]]);
      }
    });
    return access;
  },
};
